(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lib_demo", [], factory);
	else if(typeof exports === 'object')
		exports["lib_demo"] = factory();
	else
		root["lib_demo"] = factory();
})(window, function() {
return 